import { Copy, Eye, EyeOff, RotateCcw, Trash2, CheckCircle2 } from "lucide-react";
import { Button } from "@/components/ui/button";

export const DuplicatesBanner = ({ dups, removedCount, onlyDup, setOnlyDup, onRemoveAll, onRestore }) => {
  if (!dups.nGroups && !removedCount) return null;
  const restore = removedCount > 0 && (
    <Button variant="ghost" size="sm" data-testid="duplicates-restore-button" onClick={onRestore} className="text-slate-600">
      <RotateCcw className="mr-1.5 h-4 w-4" /> Ripristina {removedCount} {removedCount === 1 ? "riga rimossa" : "righe rimosse"}
    </Button>
  );

  if (!dups.nGroups) {
    return (
      <div data-testid="duplicates-banner" className="mb-4 flex flex-wrap items-center justify-between gap-3 rounded-xl border border-emerald-200 bg-emerald-50 px-4 py-3 fade-up">
        <p data-testid="duplicates-message" className="flex items-center gap-2 text-sm text-emerald-800">
          <CheckCircle2 className="h-4 w-4" /> Nessun duplicato rimasto nella tabella.
        </p>
        {restore}
      </div>
    );
  }

  return (
    <div data-testid="duplicates-banner" className="mb-4 rounded-xl border border-amber-300 bg-amber-50 px-4 py-3 fade-up">
      <div className="flex flex-col gap-3 lg:flex-row lg:items-center lg:justify-between">
        <div className="flex items-start gap-2 text-sm text-amber-900">
          <Copy className="mt-0.5 h-4 w-4 shrink-0" />
          <p data-testid="duplicates-message">
            <span className="font-semibold">{dups.extra} {dups.extra === 1 ? "movimento duplicato" : "movimenti duplicati"}</span>{" "}
            in {dups.nGroups} {dups.nGroups === 1 ? "gruppo" : "gruppi"}: stesse date, descrizione e importo.
            <span className="block text-xs text-amber-800/80">Controlla prima di rimuovere: a volte due movimenti identici sono reali. Le rimozioni valgono per il download e si perdono ricaricando la pagina.</span>
          </p>
        </div>
        <div className="flex flex-wrap gap-2">
          <Button variant="outline" size="sm" data-testid="duplicates-toggle-view" onClick={() => setOnlyDup(!onlyDup)}
            className="border-amber-300 bg-white text-amber-900 hover:bg-amber-100">
            {onlyDup ? <EyeOff className="mr-1.5 h-4 w-4" /> : <Eye className="mr-1.5 h-4 w-4" />}
            {onlyDup ? "Mostra tutte le righe" : "Mostra solo duplicati"}
          </Button>
          <Button size="sm" data-testid="duplicates-remove-all" onClick={onRemoveAll} className="bg-amber-600 text-white hover:bg-amber-700">
            <Trash2 className="mr-1.5 h-4 w-4" /> Rimuovi duplicati (tieni 1 per gruppo)
          </Button>
          {restore}
        </div>
      </div>
    </div>
  );
};
